








































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { CirurgiaConjunta } from '@/types/interfaces/CirurgiaConjunta'

@Component
export default class ComponentBackofficeEquipeCirurgiaConjunta extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get cirurgiasConjuntas() {
    return this.getBackofficeGlobalStore.solicitacao.cirurgiasConjuntas || []
  }

  get headers() {
    return [
      ...(this.mostrarNomeMedico ? [{ text: 'Nome do médico(a)', value: 'medicoNome', sortable: false }] : []),
      ...(this.mostrarNumeroConselho ? [{ text: 'Nº registro', value: 'conselhoNumero', sortable: false }] : []),
      ...(this.mostrarEspecialidade ? [{ text: 'Especialidade', value: 'especialidade', sortable: false }] : []),
      ...(this.mostrarUf ? [{ text: 'UF', value: 'uf', sortable: false }] : []),
      ...(this.mostrarEmail ? [{ text: 'E-mail', value: 'email', sortable: false }] : []),
      { text: '', value: 'acoes', sortable: false },
    ]
  }

  // Campos configuráveis por hospital em Configurações > Solicitação de cirurgia
  // (stepper.vue, seção Cirurgia conjunta) — mesmo template consumido em
  // cirurgia-conjunta.vue (fluxo do médico). tipoConselho não entra aqui: o dado
  // de CirurgiaConjunta não traz esse campo.
  get camposCirurgiaConjunta() {
    const { formulario } = this.getBackofficeGlobalStore.template
    return (formulario && formulario.cirurgiaConjunta && formulario.cirurgiaConjunta.campos) || {}
  }

  get mostrarNomeMedico() {
    return !!(this.camposCirurgiaConjunta.nomeMedico && this.camposCirurgiaConjunta.nomeMedico.habilitado)
  }

  get mostrarNumeroConselho() {
    return !!(this.camposCirurgiaConjunta.numeroConselho && this.camposCirurgiaConjunta.numeroConselho.habilitado)
  }

  get mostrarUf() {
    return !!(this.camposCirurgiaConjunta.uf && this.camposCirurgiaConjunta.uf.habilitado)
  }

  get mostrarEspecialidade() {
    return !!(this.camposCirurgiaConjunta.especialidade && this.camposCirurgiaConjunta.especialidade.habilitado)
  }

  get mostrarEmail() {
    return !!(this.camposCirurgiaConjunta.email && this.camposCirurgiaConjunta.email.habilitado)
  }

  // Abre em nova aba (mesma rota usada por backoffice-cirurgias-conjuntas-associadas.vue)
  // em vez de modal — este componente é usado dentro do ModalTriagem, e empilhar um
  // v-dialog por cima seria o v-dialog aninhado que o padrão do projeto proíbe.
  visualizarSolicitacao(item: CirurgiaConjunta) {
    if (!item.solicitacaoId) {
      return
    }

    const { href } = this.$router.resolve({ name: 'backoffice-surgery-solicitation-details', params: { solicitacaoId: item.solicitacaoId } })
    window.open(href, '_blank')
  }
}
